<template>
  <el-affix :offset="10" position="top">
    <top-nav :logo="logoProductUrl" />
  </el-affix>    
  <router-view />
  <bottom-claim :logo="logoCompanyUrl" />
</template>


<script>
// import { Store } from '@/utils/store'
import TopNav from '@/components/TopNav'
import BottomClaim from '@/components/BottomClaim'
export default {
  components: { TopNav, BottomClaim },
  data() {
    return {
      // logoUrl: require('@/assets/logo.png'),
      logoProductUrl: require('@/assets/product-logo.png'),
      logoCompanyUrl: require('@/assets/company-logo.png'),
    }
  },
  created() {
    // 设置CSS变量的值
    document.documentElement.style.setProperty('--width', window.innerWidth + 'px');
    document.documentElement.style.setProperty('--height', window.innerHeight + 'px');
  },
}
</script>


<style lang="scss">
@import '@/assets/variables.scss';
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  font-weight: 500;
  font-size: 1em;
  text-align: center;
  color: $theme-font-color;
  overflow-x: hidden;
}
:root { // 全局变量
  --width: 0;
  --height: 0;
  --themeColor: $theme-color;
  --themeColor2: $theme-color2;
  --themeFontColor2: $theme-font-color;  
}
</style>
